import styled from "@emotion/styled";
import * as React from "react";

import { StackableViewInterface } from "interfaces/stackableViewInterface";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface StyledStackedViewProps {
  visible: boolean;
}

const StyledStackedView = styled.div<StyledStackedViewProps>`
  width: 100%;
  height: 100%;
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.visible ? "block" : "none")
  };
`;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface NonOptionalStackableViewInterface {
  stackShowBackButton: boolean;
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isStackableView = (node: any): node is React.ReactElement<NonOptionalStackableViewInterface> => node;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ViewStackProps {
  currentIndex?: number;
  className?: string;
  children: React.ReactNode;
}

export default class ViewStack extends React.PureComponent<ViewStackProps & StackableViewInterface> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const { children, className, currentIndex, stackShowBackButton } = this.props;
    return (
      <StyledStackedView visible className={className}>
        {/* @ts-expect-error TS(2345): Argument of type 'ReactNode' is not assignable to ... Remove this comment to see the full error message */}
        {React.Children.map(children, (child: React.ReactChild, index: number) =>
          isStackableView(child) ? (
            <StyledStackedView
              /* eslint-disable-next-line react/no-array-index-key */
              key={index}
              visible={!!(currentIndex === undefined ? index === 0 : index === currentIndex)}
            >
              {React.cloneElement(child, {
                stackShowBackButton: stackShowBackButton || index !== 0,
              })}
            </StyledStackedView>
          ) : null
        )}
      </StyledStackedView>
    );
  }
}
